import axios from 'axios'
import ElementUI from 'element-ui';

const request = axios.create({
    // baseURL: 'https://122.51.126.72:8080/api',
    // baseURL: 'http://localhost:8081/api',

    baseURL: "https://api.0570nkql.cn:8080/api",
    timeout: 50000
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    config.headers.token = localStorage.getItem('token')

    if (config.url === "/goods/import" || config.url.includes("/goods/admin/add/image"))
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'

    return config
}, error => {
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
// request.interceptors.response.use(
//     response => {
//         let res = response.data;
//         // 如果是返回的文件
//         if (response.config.responseType === 'blob') {
//             return res
//         }
//         // 兼容服务端返回的字符串数据
//         if (typeof res === 'string') {
//             res = res ? JSON.parse(res) : res
//         }
//         // 当权限验证不通过的时候给出提示
//         if (res.code === '401') {
//             ElementUI.Message({
//                 message: res.msg,
//                 type: 'error'
//             });
//         }
//         return res;
//     },
//     error => {
//         console.log('err' + error) // for debug
//         return Promise.reject(error)
//     }
// )


export default request

